import { cn } from "@/lib/utils";

export type ChipTone = "neutral" | "strong" | "accent" | "notice" | "success" | "error";

// Status tones drawn from the Counter token set (no new colors). Packs use these for
// room state, sample custody, appointment status, membership expiry, etc.
const TONE: Record<ChipTone, string> = {
  neutral: "text-text-weak border-stroke-weak",
  strong: "text-text-strong border-stroke-strong",
  // savings, rewards, applied offers
  accent: "text-text-accent border-honey-300",
  // held, waiting, offline
  notice: "text-text-strong border-stroke-strong bg-fill-notice-weak",
  // ready, available, settled
  success: "text-honey-800 border-honey-300 bg-fill-accent-weak",
  // declined, failed, void
  error: "text-text-error border-stroke-error",
};

export function Chip({
  children,
  tone = "neutral",
  className,
}: {
  children: React.ReactNode;
  tone?: ChipTone;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-pill border px-2 py-[3px] text-sm font-semibold tracking-[0.02em]",
        TONE[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
